export const storageChargesInputMap = {
	perUnitCharges: null,
	perBoxCharges: 'Total Boxes used',
	perPalletStorageCharges: 'Total Palets used',
	perSqFtStorageCharges: 'Total area used (sq ft)',
	fixedStorageCharges: null
};
